import React, { useState, useEffect } from 'react'
import Link from 'next/link'
import Image from "next/legacy/image"
import styles from './index.module.css'

const ModalHumm = ({ onRequestClose }) => {
  useEffect(() => {
    function onKeyDown(event) {
      if (event.keyCode === 27) {
        // Close the modal when the Escape key is pressed
        onRequestClose()
      }
    }

    // Prevent scolling
    document.body.style.overflow = 'hidden'
    document.addEventListener('keydown', onKeyDown)

    // Clear things up when unmounting this component
    return () => {
      document.body.style.overflow = 'visible'
      document.removeEventListener('keydown', onKeyDown)
    }
  })

  return (
    <div className={styles.modal__backdrop}>
      <div className={styles.modal__container}>
        <div className={styles.modal__body}>
          <div className={styles.modal__closeBtn_wrapper}>
            <img
              onClick={onRequestClose}
              className={styles.modal__closeBtn}
              src="/icons/modalCloseBtn.png"
              alt="Close"
            />
          </div>
          <div className={styles.modal__logo}>
            <Image
              width={217}
              height={43}
              src="/icons/logo-humm-orange.svg"
              alt="Humm"
              unoptimized
            />
          </div>
          <div className={styles.modal__first_section}>
            <div className={styles.modal__title_container}>
              <div className={styles.modal__title_wrapper}>
                <span className={styles.modal__title}>
                  Buy Now. Pay Laaaater.
                </span>
                <span className={styles.modal__sub_title}>
                  {' '}
                  No interest ever.
                </span>
              </div>
              <ul>
                <li>Fast approval</li>
                <li>20% deposit</li>
                <li>
                  Weekly or fortnightly payment options (depending on partner store's terms)
                </li>
                <li>Available on orders over $50 and under $4000</li>
                <li>
                  Each payment frees your{' '}
                  <span className={styles.modal__text_bold}>humm</span> balance
                  to spend again
                </li>
              </ul>
            </div>
          </div>
          <div className={styles.modal__second_section}>
            <ul className={styles.modal__process}>
              <li>
                <Image
                  width={42}
                  height={33}
                  src="/icons/cart-orange.svg"
                  alt="Cart"
                  unoptimized
                />
                <p className={styles.modal__process_title}>Shop now</p>
                <p>
                  Choose <span className={styles.modal__text_bold}>humm</span>{' '}
                  as your payment option in the online checkout.
                </p>
              </li>
              <li className={styles.modal__process_arrow}>
                <Image
                  width={16}
                  height={32}
                  src="/icons/arrow-orange.svg"
                  alt="Next"
                  unoptimized
                />
              </li>
              <li>
                <Image
                  width={39}
                  height={32}
                  src="/icons/login-orange.svg"
                  alt="Login"
                  unoptimized
                />
                <p className={styles.modal__process_title}>Login or Sign up</p>
                <p>
                  You will be directed to the{' '}
                  <span className={styles.modal__text_bold}>humm</span> portal
                  to login or sign up.
                </p>
              </li>
              <li className={styles.modal__process_arrow}>
                <Image
                  width={16}
                  height={32}
                  src="/icons/arrow-orange.svg"
                  alt="Next"
                  unoptimized
                />
              </li>
              <li>
                <Image
                  width={42}
                  height={33}
                  src="/icons/watch-orange.svg"
                  alt="Complete"
                  unoptimized
                />
                <p className={styles.modal__process_title}>Complete purchase</p>
                <p>Your items will be delivered to your door.</p>
              </li>
            </ul>
          </div>
          <div className={styles.modal__third_section}>
            <div className={styles.modal__third_section_left}>
              <div className={styles.modal__third_section_content}>
                Payment plan to approved applicants only;{' '}
                <Link
                  href="https://cdn.shophumm.com/humm/uploads/sites/3/humm-Consumer-Terms-and-Conditions-1-03-2021.pdf"
                  target="_blank"
                  rel="noreferrer">

                  fees

                </Link>
                {`, `}
                <Link
                  href="https://cdn.shophumm.com/humm/uploads/sites/3/humm-Consumer-Terms-and-Conditions-1-03-2021.pdf"
                  target="_blank"
                  rel="noreferrer">

                  terms

                </Link>
                {`, `}
                <Link
                  href="https://cdn.shophumm.com/humm/uploads/sites/3/humm-Consumer-Terms-and-Conditions-1-03-2021.pdf"
                  target="_blank"
                  rel="noreferrer">

                  conditions

                </Link>
                {`, `}
                <Link
                  href="https://cdn.shophumm.com/humm/uploads/sites/3/humm-Consumer-Terms-and-Conditions-1-03-2021.pdf"
                  target="_blank"
                  rel="noreferrer">

                  minimum amounts and exclusions

                </Link>{' '}
                apply. Payment plan provided by humm BNPL Pty Ltd ABN 28 129 228
                986.
              </div>
            </div>
            <div className={styles.modal__third_section_right}>
              <p className={styles.modal__third_section_title}>
                Can anyone apply for humm?
              </p>
              <p className={styles.modal__third_section_sub_title}>
                Yes, but you need to:
              </p>
              <ul>
                <li>Be 18 years or older</li>
                <li>Be a permanent resident or citizen.</li>
                <li>
                  Hold an Australian driver's license, Australian passport or
                  Medicare card
                </li>
                <li>
                  Have a permanent job (at least 25 hours a week) or be on
                  aged/veteran’s pension
                </li>
                <li>
                  Hold an Australian Visa or Mastercard debit or credit card
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ModalHumm
